import { notify } from '@/components';
import { usePublishAnnouncementMutation } from '@/redux/announcements';

interface ActionProps {
  onSuccess?: () => any;
}

const usePublish = (props?: ActionProps) => {
  const { onSuccess } = props ?? {};
  const [publish] = usePublishAnnouncementMutation();

  return async (id: string) => {
    publish({ id })
      .unwrap()
      .then(() => {
        notify.success.t('announcements.details.published');
      })
      .then(() => onSuccess && onSuccess());
  };
};

export function usePublishAnnouncementAction(props?: ActionProps) {
  const publishAction = usePublish(props);

  return {
    publishAction,
  };
}

